<template>
  <section>
    <h3 class="primary--text"><v-icon color="primary">business</v-icon> {{ $t('transact.title') }}</h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          :widthModal="800"
        >
          <template slot="items" slot-scope="items">
            <td>{{ $datetime.format(items.item.fecha_inicio) }}</td>
            <td>{{ $datetime.format(items.item.fecha_fin) }}</td>
            <td>{{ items.item.cod_seguimiento }}</td>
            <td>{{ items.item.solicitante_nombres }} {{ items.item.solicitante_primer_apellido }} {{ items.item.solicitante_segundo_apellido }}</td>
            <td>
              <v-chip label color="success" text-color="white" v-if="items.item.estado == 'SOLICITADO'">
                {{ items.item.estado }}
              </v-chip>
              <v-chip label color="warning" text-color="white" v-if="items.item.estado == 'EN_PROCESO'">
                {{ items.item.estado }}
              </v-chip>
              <v-chip label color="danger" text-color="black" v-if="items.item.estado == 'FINALIZADO'">
                {{ items.item.estado }}
              </v-chip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>
<script>

import CrudTable from '@/common/util/crud-table/CrudTable.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';
import validate from '@/common/mixins/validate';
import tramite from './mixins/tramite';

export default {
  mixins: [ crud, validate, tramite ],
  created () {
    this.user = this.$storage.getUser();
    this.idTramite = this.user.id_tramite;
    this.solicitantes = [];
    this.getSolicitantes(4);
  },
  data () {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'tramites',
      headers: [
        { text: this.$t('transact.crud.init_date'), value: 'fecha_inicio' },
        { text: this.$t('transact.crud.end_date'), value: 'fecha_fin' },
        { text: this.$t('transact.crud.cod_tracking'), value: 'cod_seguimiento' },
        { text: this.$t('transact.crud.solicitante'), value: 'solicitante_nombres solicitante_primer_apellido solicitante_segundo_apellido' },
        { text: this.$t('common.status'), value: 'estado' }
      ],
      form: {
        cod_seguimiento: '',
        id_solicitante: ''
      },
      dataGraphql: `
        id
        fecha_inicio
        fecha_fin
        estado
        cod_seguimiento
        id_solicitante
        solicitante_nombres
        solicitante_primer_apellido
        solicitante_segundo_apellido
      `,
      filters: [
        {
          field: 'id_solicitante',
          label: this.$t('transact.crud.solicitante'),
          type: 'text',
          typeG: 'Int'
        },
        {
          field: 'cod_seguimiento',
          label: this.$t('transact.crud.cod_tracking'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'estado',
          label: this.$t('transact.crud.status'),
          type: 'select',
          typeG: 'EstadoTramite',
          items: [
            { value: '', text: 'TODOS' },
            { value: 'SOLICITADO', text: 'SOLICITADO' },
            { value: 'EN_PROCESO', text: 'EN PROCESO' },
            { value: 'FINALIZADO', text: 'FINALIZADO' }
          ]
        }
      ],
      idTramite: null,
      valid: true
    };
  },
  methods: {
    openModal (data = {}) {
      this.$refs.form.reset();
      if (data.id) {
        data.telefonos = data.telefonos.split(',');
        this.form = data;
      } else {
        this.form = {
          nombre: '',
          sigla: '',
          descripcion: '',
          email: '',
          web: '',
          direccion: '',
          telefonos: [],
          estado: ''
        };
      }
      this.$store.commit('openModal');
    },
    save () {
      if (this.$refs.form.validate()) {
        let data = Object.assign({}, this.form);

        if (data.id_solicitante.value) {
          data.id_solicitante = data.id_solicitante.value;
        }

        if (data.id) {
          delete data.id;
          this.$service.graphql({
            query: `
              mutation edit($id: Int!, $tramite: EditTramite!) {
                tramiteEdit(id: $id, tramite: $tramite) {
                  id
                }
              }
            `,
            variables: {
              id: this.form.id,
              tramite: data
            }
          }).then(response => {
            if (response) {
              this.$store.commit('closeModal');
              this.updateList();
              this.$message.success('Se actualizó el registro correctamente');
            }
          });
        } else {
          data.fecha_inicio = new Date();
          this.$service.graphql({
            query: `
              mutation add($tramite: NewTramite!) {
                tramiteAdd(tramite: $tramite) {
                  id
                }
              }
            `,
            variables: {
              tramite: data
            }
          }).then(response => {
            if (response) {
              this.$store.commit('closeModal');
              this.updateList();
              this.$message.success();
            }
          });
        }
      }
    },
    remove (item) {
      this.form.telefonos.splice(this.form.telefonos.indexOf(item), 1);
      this.form.telefonos = [...this.form.telefonos];
    }
  },
  components: {
    CrudTable
  }
};
</script>



// WEBPACK FOOTER //
// Tramite.vue?04f36794